<div class="card mb-4">
    <div class="card-body">
      <div class="mb-4 d-md-flex align-items-center justify-content-between"></div>
      <div class="row">
        <div class="col-md-12">
          <div class="row">
            <div class="col-md-10">
              <h3 class="text-center font-bold font-up danger-text">Materials List</h3>
            </div>
            <div class="col-md-2 text-right">
              <button class="btn btn-danger" (click)="deleteSelected()">Delete Selected</button>
            </div>
          </div>
        </div>
      </div>
      <ng-container *ngIf="MaterialList.length > 0">
        <div class="table-responsive">
          <table class="table mb-0 table-centered table-bordered">
            <thead>
              <tr>
                <th>Select</th>
                <th>Client Name</th>
                <th>Job Name</th>
                <th>PO Number</th>
                <th>Order Quantity</th>
                <th>Materials</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let material of MaterialList">
                <td>
                  <input type="checkbox" (change)="toggleSelection(material._id)" />
                </td>
                <td>{{ material.clientName }}</td>
                <td>{{ material.jobName }}</td>
                <td>{{ material.poNum }}</td>
                <td>{{ material.orderQty }}</td>
                <td>
                  <table>
                    <thead>
                      <tr>
                        <th>Material</th>
                        <th>Thickness</th>
                        <th>Density</th>
                        <th>Width</th>
                        <th>GSM</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let mat of material.materials">
                        <td>{{ mat.material }}</td>
                        <td>{{ mat.thickness }}</td>
                        <td>{{ mat.density }}</td>
                        <td>{{ mat.width }}</td>
                        <td>{{ mat.gsm }}</td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </ng-container>
    </div>
  </div>
  